import GxToast from "./Index";
import { notificationConfig } from "./../../../providers/NotificationProvider";

export const showSuccessToast = (toast, message, duration = 2) => {
  toast.open({
    className: "gx-notification",
    description: <GxToast toast={toast} message={message} type="Success" />,
    style: {
      padding: "0",
    },
    ...notificationConfig,
    duration: duration,
  });
};

export const showInfoToast = (toast, message, duration = 2) => {
  toast.open({
    className: "gx-notification",
    description: <GxToast toast={toast} message={message} type="Information" />,
    style: {
      padding: "0",
    },
    ...notificationConfig,
    duration: duration,
  });
};

export const showErrorToast = (toast, message, duration = 2) => {
  toast.open({
    className: "gx-notification",
    description: <GxToast toast={toast} message={message} type="Error" />,
    style: {
      padding: "0",
    },
    ...notificationConfig,
    duration: duration,
  });
};

export const showWarningToast = (toast, message, duration = 2) => {
  toast.open({
    className: "gx-notification",
    description: <GxToast toast={toast} message={message} type="Warning" />,
    style: {
      padding: "0",
    },
    ...notificationConfig,
    duration: duration,
  });
};
